import React from 'react'

function Footer() {
  return (
    <footer className='flex items-center justify-center font-mono text-gray-100 fixed bottom-0 h-20'>
        Built by Justin Rajewski 2023
    </footer>
  )
}

export default Footer